import React, {  useState, useEffect } from 'react';
import {
    Offcanvas,
    OffcanvasHeader,
    OffcanvasBody,
} from "reactstrap";
import InsertInvitationIcon from '@mui/icons-material/InsertInvitation';
//SimpleBar
import SimpleBar from "simplebar-react";
import { Avatar } from '@mui/material';
import {Chip} from '@mui/material';
import { item_details } from "../../api/requisition";
import { toast } from 'react-toastify';
import { useDispatch } from 'react-redux';
import { StorePageHeaderName } from '../../store/pageHeader/action';

const History = ({handleProductNameClick, selectedRowId}) => { 

    const dispatch = useDispatch();
    dispatch(StorePageHeaderName('History'))
  

    // open offcanvas
    const [open, setOpen] = useState(true);
    const[reqNo, setReqNo] = useState(null);
    const[reqState, setReqState] = useState(null);
    const[reqItem, setReqItem] = useState(null);
    const[reqDate, setReqDate] = useState(null);
    const[reqQty, setReqQty] = useState(null);
    const[reqApproved, setReqApproved] = useState(null);
    const[reqAllocate, setReqAllocate] = useState(null);
    const[reqValue, setReqValue] = useState(null);
    const [approvals, setApprovals] = useState([]);

    const toggleLeftCanvas = () => {
        setOpen(!open);
        handleProductNameClick(!open)
    };

    window.onscroll = function () {
        scrollFunction();
    };

    const scrollFunction = () => {
        const element = document.getElementById("back-to-top");
        if (element) {
            if (document.body.scrollTop > 100 || document.documentElement.scrollTop > 100) {
                element.style.display = "block";
            } else {
                element.style.display = "none";
            }
        }
    };

    const toTop = () => {
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
    };
    useEffect(() => {
      getItemDetails()
    
    }, [selectedRowId]); // This effect will run whenever selectedRowId changes

    const getItemDetails = async() => {
        try {
            const response = await item_details({item_id: selectedRowId});
            if (response.statusCode === 200) {
                setReqNo(response.data.getRequisition.procurementRequisition.requisition_number)
                setReqState(response.data.getRequisition.procurementRequisition.status)
                setReqItem(response.data.getRequisition.item_name)
                setReqDate(response.data.getRequisition.procurementRequisition.requisition_date)
                setReqQty(response.data.getRequisition.total_qty)
                setReqApproved(response.data.getRequisition.approved_qty)
                setReqAllocate(response.data.getRequisition.allocation_qty)
                setReqValue(response.data.getRequisition.value)

                setApprovals(response.data.getRequisition.procurementApprovalUser);
            }
        }
        catch (error) {
            console.error('Error searching requisition:', error);
            toast.error('Something went wrong while searching');
          }
    }


    return (
        <React.Fragment>
            <button
                onClick={() => toTop()}
                className="btn btn-danger btn-icon" id="back-to-top">
                <i className="ri-arrow-up-line"></i>
            </button>

            <div>
                <div className="customizer-setting d-none d-md-block">
                    <div onClick={toggleLeftCanvas} className="btn-info btn-rounded shadow-lg btn btn-icon btn-lg p-2">
                        <i className='mdi mdi-spin mdi-cog-outline fs-22'></i>
                    </div>
                </div>
                <Offcanvas isOpen={open} toggle={toggleLeftCanvas} direction="end" className="offcanvas-end border-0">
                    <OffcanvasHeader className="d-flex align-items-center bg-primary bg-gradient p-3 offcanvas-header-dark" toggle={toggleLeftCanvas}>
                        <span className="m-0 me-2 text-white">Details</span>
                    </OffcanvasHeader>
                    <OffcanvasBody className="p-0">
                        <SimpleBar className="h-100">
                            <div className="p-3 pt-3">
                            <div className="d-flex align-items-center justify-content-between">
                              <h6 className="mb-0 fw-semibold text-uppercase">{reqNo}</h6>
                              {reqState === 'Pending' && <Chip label="Waiting for response" variant="contained" className='approved_chip' color='error'/>}
                                {reqState === 'Approved' && <Chip label="Approved" variant="contained" className='approved_chip'/>}
                                {reqState === 'Rejected' && <Chip label="Rejected" variant="contained" className='rejected_chip' color="error" />}                            </div>
                                <p className="text-muted">{reqItem}</p>

                               <div className='mb-3'> <InsertInvitationIcon/><span className='ms-2'>{reqDate}</span></div>

                                <table style={{ borderCollapse: 'collapse', width: '100%' }}>
                                  <tr style={{ borderBottom: '1px solid #E8E8E8',borderTop: '1px solid #E8E8E8' }}>
                                    <td style={{ borderRight: '1px solid #E8E8E8', padding: '8px' }}><p className='mb-0 details_header'>Quantity</p><p className='mb-0'>{reqQty}</p></td>
                                    <td style={{ borderRight: '1px solid #E8E8E8', padding: '8px' }}><p className='mb-0 details_header'>Approved</p><p className='mb-0'>{reqApproved}</p></td>
                                    <td style={{ borderRight: '1px solid #E8E8E8', padding: '8px' }}><p className='mb-0 details_header'>Allocation</p><p className='mb-0'>{reqAllocate}</p></td>

                                    <td style={{ padding: '8px' }}><p className='mb-0 details_header'>Value</p><p className='mb-0'>{reqValue}</p></td>
                                  </tr>
                                </table>
                                <br/>
                                <p className="text-muted">Approved By</p>
                              
                              
                              
                                {approvals.map((approval, index) => (
                                    <div key={index} className='d-flex justify-content-between align-items-center mt-2'>
                                        <div className='d-flex gap-2'>
                                            <div><Avatar>H</Avatar></div>
                                            <div>
                                                <p className='mb-0 user_name'>{approval.user.first_name}{approval.user.last_name}</p>
                                                <p className='mb-0 user_role'>{approval.procurementRole.name}</p>
                                            </div>
                                        </div>
                                        <div> <Chip label={approval.status} variant="contained" className='approved_chip' /></div>
                                    </div>
                                ))}
          
                            </div>
                        </SimpleBar>

                    </OffcanvasBody>

                </Offcanvas>
            </div>
        </React.Fragment>
    );
};

export default History;